module.exports = __webpack_public_path__ + "img/product_70.93295fe.webp";